import * as React from 'react';
import {isEmpty} from "../utilities/Utilities";
import {useParams} from "react-router-dom";

// export class OrlenPaczka extends React.Component<Props, State> {
const OrlenPaczka = () => {
    // const params: any = useParams();

    // constructor(props: any) {
    //     super(props);
    //
    //     this.state = {
    //         kod: '35-330'
    //     }
    // }

    // componentDidMount() {
    //     let {match} = this.props;
    //
    //     if (match)
    //         if (match.params)
    //             if (!isEmpty(match.params.kod))
    //             {
    //                 this.setState({kod: match.params.kod})
    //             }
    // }

    // console.log(params.kod)
    return (
        <iframe title={'Mapa punktów Orlen Paczka'} src={`paczkaOrlen.html` } style={{width: '100%', height: '100vh'}}></iframe>
        // <iframe src={`paczkaOrlen.html?kod=${params.kod}` } style={{width: '100%', height: '100vh'}}></iframe>
    );

}


export default OrlenPaczka

